import type { FaireProductEntity } from "../../entity_types/product";

export const p_8j26mm97ha: FaireProductEntity = {
  token: "p_8j26mm97ha",
  type: "product",
  name: "St Francis Of Assisi Birdbath Figure Grey",
  brandToken: "b_6clm7lye",
  brandName: "Hi-Line Gift Ltd.",
  imageUrl:
    "https://cdn.faire.com/fastly/6728196b372c88652d4b85acd22d7fadabf2fe3d45913daf8b06c7288fb94d32.jpeg",
  galleryImageUrls: [],
  priceDollars: 138,
  description:
    "Bring a peaceful and spiritual touch to your outdoor space with the St. Francis of Assisi Birdbath Function Garden Statue. This beautifully detailed statue features St. Francis, the patron saint of animals, gently holding a birdbath, creating a serene environment for both wildlife and your garden. Made from durable, weather-resistant materials, this statue serves as both a functional birdbath and a decorative piece, perfect for attracting birds while adding a calming presence to your garden, yard, or patio.",
  tags: [],
  msrpDollars: 300,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:25.108Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
